module.exports = __webpack_public_path__ + "img/piaomeiling.8b954cb3.png";